import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { GameLogic } from '../Logic/LockCellLogic';
import { LockCellModel } from '../Models/LockCellModel';
import { CellController } from './CellController';
import { AnimationContents } from '../../../../../../AnimationContents';

export class LockCellController extends AnimationBaseController {
    $model: LockCellModel;

    private _width: number = 0;
    private _height: number = 0;

    private _screenWidth: number = 0;
    private _screenHeight: number = 0;
    private _screenScale: number = 1;

    public constructor(
        @Inject private _options,
        @Inject private _gameLogic: GameLogic,
    ) {
        super('LockCellController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.CELL_JSON,
            libraryName: 'mini_game_2_container',
        };
    }

    protected onInitialize(): void {
        this._gameLogic.randomizeCloseCells(this.$model);
        this.$model.cells.forEach((cell, ind) => {
            this.addChildController(
                {
                    instanceName: `mini_game_2.drawer_${ind}`,
                    view: CellController,
                    model: cell,
                    options: {
                        onComplete: this._options.onComplete,
                        onFail: this._options.onFail,
                    },
                },
                'drawer_' + ind,
            );
        });

        this._width = this.display.width;
        this._height = this.display.height;
    }

    protected onResize(width: number, height: number, scale: number) {
        this._screenWidth = width;
        this._screenHeight = height;
        this._screenScale = scale;

        this.updateScale();
    }

    protected onLandscape(): void {
        this.updateScale();
    }

    protected onPortrait(): void {
        this.updateScale();
    }

    private updateScale(): void {
        this.display.scale.set(Math.min(this._screenWidth / this._width / this._screenScale, this._screenHeight / this._height / this._screenScale));
    }
}
